import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import Footer from '../Footer';
import Header from '../Header';
import LoadingSpinner from '../LoadingSpinner';
import SideMenu from './components/SideMenu';
import SideRailPromos from './components/SideRailPromos';
import styles from './PageLayout.module.css';
import SHRMMessage from '../SHRMMessage';
import {
  deleteProfilePhoto,
  getProfilePhoto,
  saveProfilePhoto,
  uploadProfilePhoto,
} from '../../../services';
import { setProfilePhoto } from '../../../redux/profileSlice';
import { IProfilePhoto } from '../../../models/Profile/IProfilePhoto';
import { RootState } from '../../../redux/store';
import { setAuthenticationError } from '../../../redux/ssoUserSlice';
import Modal from '../Modal';
import { DASHBOARD_API_TOKEN_NAME } from '../../../constants';
import { history } from '../../helpers';
import { useAuth } from 'oidc-react';

type PageLayoutProps = {
  children: React.ReactNode;
  isLoading?: boolean;
  hideSideMenu?: boolean;
  hideHeaderFooter?: boolean;
};

const PageLayout = (props: PageLayoutProps) => {
  const [popupMesage, setPopupMessage] = useState('');
  const [popupMessageColor, setPopupMessageColor] = useState('');
  const [showPopupMessage, setShowPopupMessage] = useState(false);
  const isMock = window.name === 'true';
  const dispatch = useAppDispatch();
  const auth = isMock ? null : useAuth();

  const authenticationerror = useAppSelector(
    (state: RootState) => state.ssoUserReducer.authenticationerror
  );

  const handleModalClose = () => {
    sessionStorage.removeItem(DASHBOARD_API_TOKEN_NAME);
    dispatch(setAuthenticationError(false));
    history.navigate('/signin');
  };

  const handleDeletePhoto = async (id: number, ssoUUID: string) => {
    return deleteProfilePhoto(id)
      .then((response: any) => {
        return getProfilePhoto(ssoUUID);
      })
      .then((response: any) => {
        dispatch(setProfilePhoto(response.data));
      });
  };

  const handleSavePhoto = async (profilePhoto: IProfilePhoto) => {
    return uploadProfilePhoto(profilePhoto)
      .then((response: any) => {
        var updatedProfilePhoto = response.data as IProfilePhoto;
        return saveProfilePhoto(updatedProfilePhoto);
      })
      .then((_response: any) => {
        return getProfilePhoto(profilePhoto.ssouuId);
      })
      .then((response: any) => {
        dispatch(setProfilePhoto(response.data));
        window.scrollTo(0, 0);
        setPopupMessage('✔︎ Profile photo successfully uploaded.');
        setPopupMessageColor('var(--shrmGreen)');
        setShowPopupMessage(true);
      })
      .finally(() => {
        setTimeout(() => {
          setShowPopupMessage(false);
        }, 3000);
      });
  };

  return (
    <>
      {!props.hideHeaderFooter && <Header />}
      {auth.isLoading ? (
        <div style={{ padding: "9%" }}><LoadingSpinner /></div>
      ) : (
        isMock || (auth && auth.userData)) && (
        <div className={styles.container}>
          <div className={styles.side}>
            <div>
              {!props.hideSideMenu && (
                <SideMenu onDeletePhoto={handleDeletePhoto} onUploadPhoto={handleSavePhoto} />
              )}
            </div>
            <div className={styles.sideRailPromosSide}>
              <SideRailPromos />
            </div>
          </div>
          <div className={styles.main}>
            <>
              <SHRMMessage
                color={popupMessageColor}
                text={popupMesage}
                showMessage={showPopupMessage}
              />
              <Modal open={authenticationerror}>
                <div className={styles.modalHeader}>Session expired</div>
                <div className={styles.modalBody}>
                  Your session has expired. Please re-authenticate.
                </div>
                <div className={styles.modalButtons}>
                  <button className={styles.blueButton} onClick={handleModalClose}>
                    Ok
                  </button>
                </div>
              </Modal>
              {props.children}
            </>
          </div>
        </div>
      )}
      {!props.hideHeaderFooter && <Footer />}
    </>
  );
};

export default PageLayout;
